import consumer from './consumer'

// Keeps at most one ActionCable subscription per channel module across Turbo visits.
export default function managedSubscription() {
  let current = null

  return {
    ensure(config, params, mixin) {
      const key = JSON.stringify(config)
      if (current && current.key === key) return current.subscription

      this.clear()
      current = {key, subscription: consumer.subscriptions.create(params, mixin)}
      return current.subscription
    },

    clear() {
      if (!current) return

      consumer.subscriptions.remove(current.subscription)
      current = null
    }
  }
}
